import { TemplateCard, TemplateCardContent } from "./TemplateCard";

const SummaryCard = () => (
  <TemplateCard>
    <TemplateCardContent title="Hello There!">
      <p className="text-xl leading-normal text-gray-700 ">
        I'm
        <b> Ali Ciftci</b>. A <b>Front-End Web Developer</b> with over{" "}
        <b>5+ years</b> of experience in building industry-standard web apps. I
        use <b>React</b> with
        <b> TypeScript</b> and utilize tools like <b>Redux</b>, <b>Jest</b>, and
        <b> GraphQL</b> to build scalable and efficent solutions. I am always
        looking to learn and improve my skills in new technologies, for example
        this site is made using <b>Tailwind CSS</b>!
      </p>
    </TemplateCardContent>
  </TemplateCard>
);

export default SummaryCard;
